import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({ providedIn: 'root' })
export class DocumentDataService {
    constructor(
        private dataProvider: DataService
    ) { }
    DownloadDeliveryNote(model: any) {
        return this.dataProvider.GetAllwithHeaders(Urls.DeliveryNoteDownload, model);
    }
    DownloadWarrantyDocument(model: any) {
        return this.dataProvider.GetAllwithHeaders(Urls.WarrantyDocumentDownload, model);
    }
    SendWarrantyDocument(model: any) {
        return this.dataProvider.GetAllwithHeaders(Urls.WarrantyDocumentSend, model);
    }
    DownloadSignedWarrantyDocument(model: any) {
        return this.dataProvider.GetAllwithHeaders(Urls.WarrantyDocumentDownloadSigned, model);
    }
    WarrantyDocumentStatus(workOrderNo: string,dealerId: string) {
        return this.dataProvider.Get<GenericResponse<boolean>>(Urls.WarrantyDocumentStatus, workOrderNo, dealerId).toPromise();
    }
    GetPendingSignDocument(workOrderNo: string) {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetPendingSignDocument, workOrderNo).toPromise();
    }

    DownloadOrderDocument(model: any) {
        return this.dataProvider.GetAllwithHeaders(Urls.OrderDocumentDownload, model);
    }
}